import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../../stateManager/store';
import Tour from 'reactour'
import { setGuideVisible, setStageIndex, setStepIndex, setSteps } from '../../../../../../stateManager/store/onboarding/action';
import './onboarding.css'
// import stepJson from './onboarding2.json'
import { useHistory } from 'react-router-dom';
import { updateOnboarding } from '../../../../../../helpers/onboardingHelper';
import dragAndDropAnimation from '../../../../../../assets/svg/sidemenu/dragAndDropFormBuilder.svg';
import doubleClickForm from '../../../../../../assets/svg/sidemenu/doubleClickForm.svg';
import doubleClickService from '../../../../../../assets/svg/sidemenu/doubleClickService.svg';
import {ReactComponent as Confetti} from '../../../../../../assets/svg/sidemenu/confetti.svg';
import dotPattern from '../../../../../../assets/svg/sidemenu/dot-pattern.svg';
import Axios from 'axios';
import { setServiceTaskExist } from '../../../../../../stateManager/store/onboarding/action';



interface OnboardingProps {

}


const Onboarding: React.FC<OnboardingProps> = ({ }) => {

  const { guideVisible, info: onboardingInfo, loading } = useSelector((state: AppState) => state.onboarding)
  const { stepIndex, stageIndex, level } = onboardingInfo;
  const dispatch = useDispatch();
  const [step, setStep] = useState<any[]>([])
  const [stages, setStages] = useState<any[]>([])
  const [stepJson, setStepJson] = useState<any[]>([])

  const setBpmnSteps = (bpmnSteps: any[]) => {
    const steps = bpmnSteps.map((bpmnStep: any) => {
      const { content, elementType = '' } = bpmnStep;
      if (bpmnStep.selector === '.serviceTaskNode_1') {
        dispatch(setServiceTaskExist(true))
      }
      if (bpmnStep.type === "end") {
        return {
          selector: bpmnStep.selector,
          content: ({ goTo, inDOM }: any) => (
            <EndStep
              buttonText={`${content.buttonText} ${(stageIndex + 2)}`}
              showBadge={content.showBadge}
              goTo={goTo}
              inDOM={inDOM}
              nextHandler={content.nextHandler}
              title={content.title}
              stepJson={stepJson}
              content={content.content} />
          ),
          position: bpmnStep.position,
          style: bpmnStep.style,
        }
      } else {
        return {
          selector: bpmnStep.selector,
          position: bpmnStep.position,
          style: bpmnStep.style,
          action: bpmnStep.action ? eval(`${bpmnStep.action}`) : () => { },
          mutationObservables: [`${bpmnStep.selector}`],
          resizeObservables: [`${bpmnStep.selector}`],
          maskSpace: bpmnStep.maskSpace,
          content: ({ goTo, inDOM }: any) => (
            <OnboardingTooltip
              selector={bpmnStep.selector}
              backHandler={content.backHandler}
              showBadge={content.showBadge}
              goTo={goTo}
              inDOM={inDOM}
              nextHandler={content.nextHandler}
              title={content.title}
              content={content.content}
              stepJson={stepJson}
              animation={bpmnStep.animation}
              elementType={elementType}
              readmore={content.readmore}
              copyText={content.copyText}
            />
          )
        }
      }
    })
    return steps
  }

  const setFormSteps = (formSteps: any[]) => {
    const steps = formSteps.map((formStep: any) => {
      const { content, elementType = '' } = formStep;
      if (formStep.type === "end") {
        return {
          selector: formStep.selector,
          content: ({ goTo, inDOM }: any) => (
            <EndStep
              buttonText={`${content.buttonText} ${(stageIndex + 2)}`}
              showBadge={content.showBadge}
              goTo={goTo}
              inDOM={inDOM}
              nextHandler={content.nextHandler}
              title={content.title}
              stepJson={stepJson}
              content={content.content} />
          ),
          position: formStep.position,
          style: formStep.style
        }
      } else {
        return {
          selector: formStep.selector,
          position: formStep.position,
          style: formStep.style,
          action: formStep.action ? eval(`${formStep.action}`) : () => { },
          mutationObservables: [`${formStep.selector}`],
          resizeObservables: [`${formStep.selector}`],
          maskSpace: formStep.maskSpace,
          content: ({ goTo, inDOM }: any) => (
            <OnboardingTooltip
              selector={formStep.selector}
              backHandler={content.backHandler}
              showBadge={content.showBadge}
              goTo={goTo}
              inDOM={inDOM}
              nextHandler={content.nextHandler}
              title={content.title}
              content={content.content}
              stepJson={stepJson}
              animation={formStep.animation}
              elementType={elementType}
              readmore={content.readmore}
              copyText={content.copyText}
            />
          )
        }
      }
    })
    return steps
  }


  const setOnboardDetails = (stepData: any[]) => {
    const stgs: any[] = []
    stepData && stepData.forEach((stg) => {
      let stage: any[] = []
      stg.forEach((stp: any) => {
        const { content, elementType = '' }: any = stp;
        if (stp.type === "end") {
          stage.push({
            selector: stp.selector,
            content: ({ goTo, inDOM }: any) => (
              <EndStep
                buttonText={`${content.buttonText} ${(stageIndex + 2)}`}
                showBadge={content.showBadge}
                goTo={goTo}
                inDOM={inDOM}
                nextHandler={content.nextHandler}
                title={content.title}
                stepJson={stepData}
                content={content.content} />
            ),
            position: stp.position,
            style: stp.style
          })
        } else if (stp.type === 'bpmnJourney') {
          const bpmnSteps = setBpmnSteps(stp.bpmnSteps)
          stage = [...stage, ...bpmnSteps]
        } else if (stp.type === "formBuilder") {
          const formSteps = setFormSteps(stp.formSteps)
          stage = [...stage, ...formSteps]
        } else {
          stage.push({
            selector: stp.selector,
            position: stp.position,
            style: stp.style,
            action: stp.action ? eval(`${stp.action}`) : () => { },
            mutationObservables: [`${stp.selector}`],
            resizeObservables: [`${stp.selector}`],
            maskSpace: stp.maskSpace,
            content: ({ goTo, inDOM }: any) => (
              <OnboardingTooltip
                selector={stp.selector}
                backHandler={content.backHandler}
                showBadge={content.showBadge}
                goTo={goTo}
                inDOM={inDOM}
                nextHandler={content.nextHandler}
                title={content.title}
                content={content.content}
                stepJson={stepData}
                animation={stp.animation}
                elementType={elementType}
                position={stp.position}
                readmore={content.readmore}
                copyText={content.copyText}
              />
            )
          })
        }
      })
      stgs.push(stage)
    })

    setStages(stgs)
    if (stgs[stageIndex]) {
      setStep(stgs[stageIndex])
      dispatch(setSteps(stgs[stageIndex]))
    } else {
      dispatch(setGuideVisible(false))
    }
  }

  const fetchStepJson = () => {
    if (!level) {
      if(guideVisible){
        dispatch(setGuideVisible(false))
      }
      return;
    }

    Axios.get(`${level}Onboarding.json`)
    .then((response: any) => {
      setStepJson(response.data)
      setOnboardDetails(response.data)
    }).catch((error: any) => {
      console.error("Failed to fetch Onboarding Json --> ",error)
    })
  }

  useEffect(() => {
      fetchStepJson()
    return () => {
      fetchStepJson()
    }
  }, [level])


  const getCurrentStep = (step: number) => {
    dispatch(setStepIndex(step));
  }

  useEffect(() => {
    if (stages.length) {
      if (stages[stageIndex]) {
        setStep(stages[stageIndex])
        dispatch(setSteps(stages[stageIndex]))
      } else {
        setStep([])
        dispatch(setSteps([]))
        dispatch(setGuideVisible(false))
      }
    }
  }, [stageIndex, stepJson])

  const getMaskSpace = () => {
    let maskSpace = 3;
    if (step[stepIndex] && step[stepIndex].maskSpace) {
      return step[stepIndex].maskSpace;
    }
    return maskSpace;
  }


  if (loading) {
    return (<div></div>)
  }

  return (
    <div>
      {(step && step.length) ? <Tour
        onRequestClose={() => { }}
        isOpen={guideVisible}
        disableDotsNavigation
        steps={step}
        showCloseButton={false}
        showNavigation={false}
        showButtons={false}
        startAt={stepIndex}
        goToStep={stepIndex}
        rounded={5}
        getCurrentStep={getCurrentStep}
        disableFocusLock={true}
        highlightedMaskClassName='highlighted_mask'
        disableKeyboardNavigation={true}
        maskSpace={getMaskSpace()}
        className='onboarding_tooltip'
        maskClassName='onboarding_mask'
      >
      </Tour> : <></>}
    </div>
  );
};

const OnboardingTooltip = (props: any) => {
  const { title, content, nextHandler, showBadge, backHandler, animation, selector, position, elementType, readmore="", copyText } = props;
  const dispatch = useDispatch()
  const { info, steps } = useSelector((state: AppState) => state.onboarding)
  const { userName } = useSelector((state: AppState) => state.user.data.user)
  const { stepIndex } = info;
  const elementTypes = ['button', 'bpmnNode'];
  const tooltipRef: any = useRef()
  const [backVisible, setBackVisible] = useState(backHandler)
  const [textCopied, setTextCopied] = useState(false);
  const history = useHistory()

  const setStep = () => {
    dispatch(setStepIndex(stepIndex + 1));
  }

  const setBack = () => {
    if (steps[stepIndex - 1] && steps[stepIndex - 1].selector && document.querySelector(steps[stepIndex - 1].selector)) {
      dispatch(setStepIndex(stepIndex - 1));
    }
  }

  useEffect(() => {
    if (backHandler && steps[stepIndex - 1] && steps[stepIndex - 1].selector && document.querySelector(steps[stepIndex - 1].selector)) {
      setBackVisible(true)
    } else {
      setBackVisible(false)
    }
  }, [stepIndex])

  useEffect(() => {
    const observer = new MutationObserver((mutations: any) => {
      for (let mutation of mutations) {
        for (let node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;
          const selectorElement = document.querySelector(selector);
          if (selectorElement) {
            const rippleElement = document.querySelector('.ripple_animation');
            if (rippleElement) {
              rippleElement.classList.remove("ripple_animation");
            }
            if (elementTypes.includes(elementType)) {
              selectorElement.classList.add("ripple_animation");
            }
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, [selector]);

  useEffect(() => {
    const selectorElement = document.querySelector(selector);
    const rippleElement = document.querySelector('.ripple_animation');
    if (rippleElement) {
      rippleElement.classList.remove("ripple_animation");
    }
    if (selectorElement && elementTypes.includes(elementType)) {
      selectorElement.classList.add("ripple_animation");
    }
  }, [selector])

  const getAnimationSVG = () => {
    if (animation === "dragAndDrop") {
      return dragAndDropAnimation;
    } else if (animation === "doubleClickForm") {
      return doubleClickForm
    } else if (animation === "doubleClickService") {
      return doubleClickService
    }
  }

  const handleSkip = async() => {
    const payload = {
        ...info,
        skipTour: true
    }
    await updateOnboarding(userName, payload)
    dispatch(setGuideVisible(false))
    history.push('/home')
}

const handleCopy = () => {
  if (copyText) {
    const elem = document.createElement('textarea');
    elem.value = JSON.stringify(copyText, null, 1).slice(1,-1);
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
    setTextCopied(true);
    setTimeout(() => setTextCopied(false), 2000)
  }
}

  return (
    <div className={`onboarding_tlp`} ref={tooltipRef} style={{ position: "relative" }}>
      <div className='onboarding_tlp_arrow_bottom'>
        {animation && <div className='onboarding_card' style={{ backgroundImage: `url(${dotPattern})` }}>
          <object data={getAnimationSVG()}></object>
        </div>}
        {title && <div className='ob_tooltip_tle'>
          <span>{title}</span>
        </div>}
        <div className='ob_tooltip_cnt'>
          <span>{content}</span>
          {readmore && <a style={{marginLeft: "5px", textDecoration: "underline"}} href={readmore} target='_blank' >Learn More</a>}
          {(!textCopied && copyText) && <svg onClick={handleCopy} style={{cursor: "pointer", marginLeft: "10px"}} width="19" height="19" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M12.9 10.265v3.57C12.9 16.81 11.71 18 8.735 18h-3.57C2.19 18 1 16.81 1 13.835v-3.57C1 7.29 2.19 6.1 5.165 6.1h3.57c2.975 0 4.165 1.19 4.165 4.165z" fill="#B9BEC6" fill-opacity="0.3" stroke="#B9BEC6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18 5.165v3.57c0 2.975-1.19 4.165-4.165 4.165H12.9v-2.635C12.9 7.29 11.71 6.1 8.735 6.1H6.1v-.935C6.1 2.19 7.29 1 10.265 1h3.57C16.81 1 18 2.19 18 5.165z" fill="#B9BEC6" fill-opacity="0.3" stroke="#B9BEC6" stroke-linecap="round" stroke-linejoin="round"></path></svg>}
          {textCopied && <span className='ml-2 text-green-500'>Copied!</span>}
        </div>
        {props.defaultValue && <div>{props.defaultValue}</div>}
        <div className='ob_tlp_footer' style={{ justifyContent: "space-between" }}>
          <span onClick={handleSkip}>Skip Tour</span>
          <div className='ob_tlp_footer_btns'>
            {backVisible && <button className='ob_tlp_back' onClick={setBack}>Back</button>}
            {nextHandler && <button className='ob_tlp_next' onClick={setStep}>Next</button>}
          </div>
        </div>
      </div>
    </div>
  )
}

const EndStep = (props: any) => {
  const { title, content, nextHandler, buttonText, stepJson = [] } = props;
  const dispatch = useDispatch()
  const history = useHistory();
  const { info: onboardingInfo } = useSelector((state: AppState) => state.onboarding)
  const { userName } = useSelector((state: AppState) => state.user.data.user)
  const nextStage = () => {
    const stageIndex = onboardingInfo.stageIndex
    let payload = {
      ...onboardingInfo,
      stepIndex: 0,
      stageIndex: stageIndex + 1
    }
    if (stageIndex + 1 === stepJson.length) {
      payload = {
        ...payload,
        guideCompleted: true,
        stageIndex: stageIndex + 1
      }
    } else {
      dispatch(setStageIndex(stageIndex + 1))
    }
    updateOnboarding(userName, payload)
    dispatch(setGuideVisible(false))
    dispatch(setStepIndex(0))
    history.push("/home")
  }

  useEffect(() => {
    const rippleElement = document.querySelector('.ripple_animation');
    if (rippleElement) {
      rippleElement.classList.remove("ripple_animation");
    }
  }, [])

  return (
    <div className='onboarding_end_step'>
      <span>
        <Confetti />
      </span>
      {title && <h2>{title}</h2>}
      {content && <span>{content}</span>}
      <div className='ob_end_btn'>
        {nextHandler && <button onClick={nextStage}>{onboardingInfo.stageIndex === stepJson.length - 1 ? "Go to Home" : buttonText}</button>}
      </div>
    </div>
  )
}
export default Onboarding;
